import { ReadJsonDataWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ReadJsonData')
export class ReadJsonDataNodeSchemaProvider extends SchemaProvider<ReadJsonDataWorkflowNode> {}
